















































































import { Component, Prop, Vue, Ref } from "vue-property-decorator";
import { ValidationRules } from "_P/validate";
import { Address, InsuranceCard } from "@/services/index.defs";
import { GaHelper } from "@/core/helpers/ga";
import { DefaultCopy } from "_P/copyobj";
import { differenceInCalendarDays } from "date-fns";
import { EventName, sendPostMessageEvent } from '@/utils/analyticMessages';

@Component
export default class PrecheckDate extends Vue {
    @Prop(Boolean) alignCenter: boolean;
    Rules = ValidationRules;
    isValid = true;

    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }
    insuranceMonthItems = [
        { value: 3, title: "3 месяца" },
        { value: 6, title: "6 месяцев" },
        { value: 9, title: "9 месяцев" },
        { value: 12, title: "12 месяцев" }
    ];

    cityAddress: Address = null;
    created() {
        this.cityAddress = DefaultCopy(this.card.owner.address);
        let addressParts = this.cityAddress.value.split(",");
        let importantParts = addressParts.filter(
            x =>
                !x.trim().startsWith("пр-кт") &&
                !x.trim().startsWith("ул") &&
                !x.trim().startsWith("д ") &&
                !x.trim().startsWith("кв") &&
                !x.trim().endsWith("б-р") &&
                !x.trim().endsWith("пр-кт")
        );
        this.cityAddress.value = importantParts.join(", ");
        if (this.card.beginDate?.getTime() < new Date().getTime()) {
            this.card.beginDate = new Date().addDays(4);
        }
    }
    destroyed() {
        const ownAddress = this.card.owner.address;
        if (
            this.cityAddress.region != ownAddress.region ||
            this.cityAddress.city != ownAddress.city ||
            this.cityAddress.state != ownAddress.state
        ) {
            this.card.owner.address = this.cityAddress;
            if (this.card.insurerIsOwner) {
                this.card.insurer.address = this.cityAddress;
            }
        }
    }

    mounted() {
        GaHelper.send("osagoparams");
    }
    @Ref("form") form: { validate: Function };
    nextStep() {
        let isValid = this.form.validate();
        if (!isValid) return;

        sendPostMessageEvent(EventName.DateNewPolicy);

        this.$emit("next");
    }
}
